import { FinalImpactScoreType } from '@upright/common/model/output/scores/types';
import { BottomBar } from './desktop';

export function AggregateResultArea(props: { scoreUnit: FinalImpactScoreType | undefined }) {
  return <BottomBar scoreUnit={props.scoreUnit} />;
}
